import { pagesConfig } from '../../../shared/pages-config';
import RulesEngineFormPage from './rules-engine-form-page';

export default function CloneRulePage() {
  return (
    <RulesEngineFormPage pageMode="clone" title={pagesConfig.cloneRule.name} />
  );
}
